import React from 'react'
import { recaptchaMap } from './recaptchaMap'

const RecaptchaFactory = ({ version = '', ...rest }) => {
	const RecaptchaComp = recaptchaMap[version];
	
	return <RecaptchaComp {...rest} />;
}

export default RecaptchaFactory;